module.exports = __webpack_public_path__ + "img/bg01.f7c7329b.png";